import { removeFromStorage } from '@/shared/storageFunctions';

type UnregisterServiceWorkerProps = {
  preserveLocalStorage?: boolean;
  /** Quando false, não grava a flag `reload` lida em App (evita segundo reload). */
  setReloadFlag?: boolean;
};

const COOKIE_EXPIRE = 'Thu, 01 Jan 1970 00:00:00 GMT';

const clearAllCookies = () => {
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const eqPos = part.indexOf('=');
    const name = (eqPos > -1 ? part.slice(0, eqPos) : part).trim();
    if (!name) continue;
    document.cookie = `${name}=;expires=${COOKIE_EXPIRE};path=/`;
    document.cookie = `${name}=;expires=${COOKIE_EXPIRE};path=/;domain=${window.location.hostname}`;
  }
};

const clearCaches = async () => {
  if (typeof caches === 'undefined') return;
  const cacheNames = await caches.keys();
  await Promise.allSettled(
    cacheNames.map((name) => caches.delete(name))
  );
};

export const unregisterServiceWorker = async (props: UnregisterServiceWorkerProps) => {
  const preserveLocalStorage = props?.preserveLocalStorage ?? false;
  const setReloadFlag = props?.setReloadFlag ?? true;
  try {
    const registrations = await navigator.serviceWorker?.getRegistrations();
    await Promise.all(registrations?.map((r) => r.unregister()) ?? []);

    await clearCaches();
    clearAllCookies();

    if (!preserveLocalStorage) {
      removeFromStorage('cart_id');
      // removeFromStorage('order_numbers');
      removeFromStorage('selected_client');
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.clear();
      }
    }

    if (setReloadFlag) {
      window.localStorage.setItem('reload', 'true');
    }
  } catch (error) {
    console.error('Erro ao limpar cache:', error);
  }
  // window.location.reload()
};